export const ConfigTypes = [
  {id: "CAFE_BAZAAR_ACCESS_TOKEN", name: "CAFE_BAZAAR_ACCESS_TOKEN"},
  {id: "CAFE_BAZAAR_REFRESH_TOKEN", name: "CAFE_BAZAAR_REFRESH_TOKEN"},
  {id: "TEST_FLIGHT_REDIRECT_URL", name: "TEST_FLIGHT_REDIRECT_URL"},
  {id: "TEST_FLIGHT_REDIRECT_URL_ALTERNATIVE_1", name: "TEST_FLIGHT_REDIRECT_URL_ALTERNATIVE_1"},
  {id: "WEBSITE_DOWNLOAD_DEFAULT_URL", name: "WEBSITE_DOWNLOAD_DEFAULT_URL"},
  {id: "FAQ_LAST_UPDATED_AT", name: "FAQ_LAST_UPDATED_AT"},
  {id: "DB_MIGRATION_VERSION", name: "DB_MIGRATION_VERSION"},
  {id: "KARAFS_ADS_DAY_AFTER_REGISTERATION", name: "KARAFS_ADS_DAY_AFTER_REGISTERATION"},
  {id: "KARAFS_ADS_SMS_TEXT", name: "KARAFS_ADS_SMS_TEXT"},
  {id: "KARAFS_ADS_REGISTER_PERCENTAGE", name: "KARAFS_ADS_REGISTER_PERCENTAGE"},
  {id: "KARAFS_AD_ACTIVE", name: "KARAFS_AD_ACTIVE"},

];